import { applicationReducers } from '../partials/Applications/reduxState/reducer';

export const fieldsMapReducers = {
  ...applicationReducers,
};
